import Svg, { ClipPath, Defs, G, Path, Rect } from 'react-native-svg';

export const BrandIconAblyPay = () => {
  return (
    <Svg width="61" height="13" viewBox="0 0 61 13" fill="none">
      <G clipPath="url(#clip0_5997_185457)">
        <Path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M4.3189 2.21326L0.585938 10.6784H2.63794L3.44135 8.84964H7.0628L7.86621 10.6784H9.91793L6.18525 2.21326H4.3189ZM5.25806 4.73204L6.33326 7.19061H4.1706L5.25806 4.73204Z"
          fill="#1F1F1F"
        />
        <Path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M22.6895 2.21326V10.6784H29.3255V8.99498H24.7236V2.21326H22.6895Z"
          fill="#1F1F1F"
        />
        <Path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M36.5281 2.21326L34.5706 5.36188L32.6137 2.21326H30.4233L33.5599 7.33596V10.6784H35.5818V7.33596L38.7184 2.21326H36.5281Z"
          fill="#1F1F1F"
        />
        <Path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M17.4441 8.31541C17.4441 8.81865 16.9334 9.23033 16.4123 9.23033H15.9013V9.23061H14.3055V7.36924H15.9013V7.36951H16.4123C16.9334 7.36951 17.4441 7.78147 17.4441 8.28471V8.31541ZM14.3055 3.66102H15.909V3.66129H16.0941C16.6152 3.66129 17.0416 4.07298 17.0416 4.57622V4.60719C17.0416 5.11043 16.6152 5.52212 16.0941 5.52212H15.909V5.52239H14.3055V3.66102ZM17.8174 6.24326C17.8111 6.24189 17.8049 6.23997 17.7986 6.2386C17.8279 6.22956 17.8807 6.21804 17.9116 6.2079C19.1807 5.81293 19.051 4.34461 19.051 4.34461C19.051 3.20054 17.9505 2.26205 16.7762 2.21901L14.5888 2.21353L14.574 2.21381L12.2495 2.21326L12.2509 10.6773L14.5646 10.6778H14.5757L17.3572 10.6784C18.5409 10.6784 19.5077 9.74728 19.5077 8.6043V8.27128C19.5077 7.28153 18.7808 6.44856 17.8174 6.24326Z"
          fill="#1F1F1F"
        />
        <Path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M55.9396 5.11029H54.7446L56.8479 9.95364L55.1753 13.6524H56.4295L60.3273 5.11029H59.1561L57.4122 8.80317L55.9396 5.11029Z"
          fill="black"
        />
        <Path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M50.9978 4.9895C50.4804 4.9895 50.0144 5.12797 49.6029 5.40587C49.2031 5.67328 48.8866 6.02442 48.6539 6.45772L48.6532 6.45913C48.4285 6.89331 48.3164 7.36481 48.3164 7.87197C48.3164 8.37136 48.4286 8.84254 48.6528 9.2841L48.654 9.28621C48.8865 9.7193 49.2026 10.0742 49.6018 10.3495L49.6039 10.3508C50.0153 10.6203 50.481 10.7544 50.9978 10.7544C51.2966 10.7544 51.5729 10.7128 51.8258 10.6283L51.8277 10.6276C52.0862 10.5356 52.3207 10.4098 52.5304 10.2499L52.5324 10.2483C52.6614 10.1447 52.781 10.033 52.8909 9.91319V10.6337H53.9441V5.11025H52.8909V5.83338C52.689 5.61784 52.4564 5.43763 52.1935 5.29302C51.8465 5.08962 51.4468 4.9895 50.9978 4.9895ZM50.2252 6.30567C50.4876 6.1327 50.7881 6.04533 51.1303 6.04533C51.4724 6.04533 51.7729 6.13272 52.0353 6.30568L52.0372 6.30682C52.3031 6.47448 52.5114 6.69485 52.6633 6.96909C52.8148 7.24256 52.8909 7.54285 52.8909 7.87197C52.8909 8.1924 52.815 8.49303 52.663 8.77537C52.5111 9.0495 52.3026 9.27402 52.0363 9.44976C51.7739 9.61495 51.473 9.69861 51.1303 9.69861C50.7876 9.69861 50.4867 9.61495 50.2243 9.44976C49.958 9.27402 49.7495 9.0495 49.5975 8.77537C49.4455 8.49302 49.3697 8.1924 49.3697 7.87197C49.3697 7.54285 49.4458 7.24256 49.5972 6.96909C49.7491 6.69485 49.9575 6.4745 50.2234 6.30684L50.2252 6.30567Z"
          fill="black"
        />
        <Path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M45.376 2.17725H42.6113V10.6688H43.7348V7.42072H45.376C45.8862 7.42072 46.3471 7.31148 46.7552 7.08975L46.7561 7.08926C47.1695 6.86076 47.5003 6.55061 47.746 6.15965L47.7467 6.1585C47.9943 5.75611 48.1166 5.29956 48.1166 4.79295C48.1166 4.27073 47.9904 3.80899 47.7334 3.41325C47.4873 3.02211 47.1558 2.71956 46.7411 2.50712C46.3265 2.28669 45.8706 2.17725 45.376 2.17725ZM43.7348 6.34299V3.25498H45.4964C45.8131 3.25498 46.0758 3.32297 46.2907 3.45231L46.2955 3.45494C46.5201 3.57849 46.6885 3.7514 46.804 3.97579L46.8067 3.98056C46.9291 4.19731 46.9932 4.45836 46.9932 4.7688C46.9932 5.06024 46.9264 5.32684 46.7935 5.57109L46.7928 5.57246C46.6681 5.80785 46.493 5.99452 46.2655 6.13436L46.2638 6.13547C46.0483 6.27237 45.7942 6.34299 45.4964 6.34299H43.7348Z"
          fill="black"
        />
      </G>
      <Defs>
        <ClipPath id="clip0_5997_185457">
          <Rect width="60.6667" height="13" fill="white" />
        </ClipPath>
      </Defs>
    </Svg>
  );
};
